<script>
export let className = ""
</script>

<div class="z-10 {className}">
  <slot />
</div>
